/* eslint-disable ordered-imports/ordered-imports */
import { lazyLoad, LazyLoadedComponent, PlatformRoute } from '~/libs/core'
import { learnRoutes } from '~/apps/learn'
import { devCenterRoutes } from '~/apps/dev-center'
import { campusRoutes } from '~/apps/campus'
import { profilesRoutes } from '~/apps/profiles'
import { accountsRoutes } from '~/apps/accounts'
import { onboardingRoutes } from '~/apps/onboarding'
import { walletRoutes } from '~/apps/wallet'
import { walletAdminRoutes } from '~/apps/wallet-admin'
import { copilotsRoutes } from '~/apps/copilots'
import { adminRoutes } from '~/apps/admin'
import { reportsRoutes } from '~/apps/reports'
import { salesRoutes } from '~/apps/sales'
import { reviewRoutes } from '~/apps/review'
import { workRoutes } from '~/apps/work'
import { calendarRoutes } from '~/apps/calendar'
import { engagementsRoutes } from '~/apps/engagements'
import { customerPortalRoutes } from '~/apps/customer-portal'
import { procurementRoutes } from '~/apps/procurement'
import { statusRoutes } from '~/apps/status'
import { supportRoutes } from '~/apps/support'
import { thriveRoutes } from '~/apps/thrive'
import { legacyOpportunityRoutes, opportunitiesRoutes } from '~/apps/opportunities'
import { analyticsRoutes } from '~/apps/analytics'
import { contactRoutes } from '~/apps/contact'
import { gigsRoutes } from '~/apps/gigs'

const Home: LazyLoadedComponent = lazyLoad(
    () => import('./routes/home'),
    'HomePage',
)

const NotFound: LazyLoadedComponent = lazyLoad(
    () => import('./routes/not-found'),
    'NotFoundPage',
)

const homeRoutes: ReadonlyArray<PlatformRoute> = [
    {
        element: <Home />,
        id: 'Home page',
        route: '',
    },
]

// Catch-all for paths Platform UI is served for but does not own a route for,
// eg. `/opportunities` on the Topcoder apex host. React-router ranks the `*`
// path last, so this never shadows a route declared above.
const notFoundRoutes: ReadonlyArray<PlatformRoute> = [
    {
        element: <NotFound />,
        id: 'Not found page',
        route: '*',
    },
]

export const platformRoutes: Array<PlatformRoute> = [
    // NOTE: Order matters here bc the active tool
    // is determined by finding the first route
    // that matches the current path
    ...onboardingRoutes,
    ...legacyOpportunityRoutes,
    ...opportunitiesRoutes,
    ...gigsRoutes,
    ...devCenterRoutes,
    ...campusRoutes,
    ...copilotsRoutes,
    ...learnRoutes,
    ...profilesRoutes,
    ...walletRoutes,
    ...walletAdminRoutes,
    ...accountsRoutes,
    ...reviewRoutes,
    ...workRoutes,
    ...calendarRoutes,
    ...engagementsRoutes,
    ...procurementRoutes,
    ...analyticsRoutes,
    ...contactRoutes,
    ...statusRoutes,
    ...supportRoutes,
    ...thriveRoutes,
    ...homeRoutes,
    ...adminRoutes,
    ...reportsRoutes,
    ...salesRoutes,
    ...customerPortalRoutes,
    ...notFoundRoutes,
]
